import styled from "@emotion/styled"

export const PeriodicReportSettingsWrapper = styled.div`
  background: var(--cms-surface-secondary);
  border-radius: 18px;
  padding: 24px;
  box-shadow: 0 30px 80px rgba(45, 47, 78, 0.18);
  display: flex;
  flex-direction: column;
  gap: 24px;

  .section {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  .windows {
    display: flex;
    gap: 12px;
    flex-wrap: wrap;
  }

  .window-label {
    flex: 1 1 180px;
  }

  .helper-text {
    font-size: 13px;
    color: var(--cms-text-secondary);
  }
`
